var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBannerVector2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 295,
    viewBox: "0 0 1440 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1911 323.84C1578.77 382.382 1476.28 88.1437 1149.55 126.323C1048.6 138.121 1032.16 149.675 846 211.892C656 275.392 356.166 278.032 164.5 187C-44.4021 87.7812 -0.855148 -35.6663 -45.5 10L-70 965.892H1911V323.84Z",
    fill: "#E5EDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerVector2);
export default __webpack_public_path__ + "static/media/homeBannerVector2.80779cf37c1888b473584cb11e04d71c.svg";
export { ForwardRef as ReactComponent };